export var TicketEmptyStates;
(function (TicketEmptyStates) {
    TicketEmptyStates["NO_COMMENT"] = "No comment provided";
    TicketEmptyStates["NO_SUBJECT"] = "No subject provided";
})(TicketEmptyStates || (TicketEmptyStates = {}));
//# sourceMappingURL=tickets.js.map